import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

interface DeleteDialogProps {
    show: boolean;
    message: string;
    onHide: () => void;
    onAccept: () => void;    
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
    show,
    onHide,
    onAccept,
    message
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="danger"
                    onClick={(e) => onAccept()}
                >
                    Delete
                </Button>
                <Button variant="secondary" onClick={(e) => onHide()}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteDialog;
